// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormFooter_wrapper__VUzlm","helperLink":"FormFooter_helperLink__DMiNk"};